import * as _ from 'underscore';

import { setRootAdminUiState } from '../app/actions/spaces/RootAdminUiStateActions';
import { getAppStore } from '../app/AppStore';
import { Tableau } from '../common/utilities/TableauLog';
import { L10n } from './L10n/L10n';
import { Module } from './Module';
import WebHttpClient from '../httpClient/WebHttpClient';

export interface UserStateParams {
  domainName: string;
  username: string;
}

Module.instance().config(<any[]>[
  '$httpProvider',
  '$locationProvider',
  '$sceProvider',
  (
    $httpProvider: ng.IHttpProvider,
    $locationProvider: ng.ILocationProvider,
    $sceProvider: any
  ) => {
    $locationProvider.hashPrefix('');
    function goToFatalErrorState(message: string) {
      Tableau.Logger().error(message);

      getAppStore().dispatch(setRootAdminUiState('fatal'));
    }

    $httpProvider.interceptors.push(['$q', '$injector', ($q, $injector) => {
      const apiRequestRegex = new RegExp('^' + WebHttpClient.API_PREFIX);
      return {
        request: (config: ng.IRequestConfig) => {
          const isGet = config.method === 'GET';
          const isInline = /^inline_/.test(config.url);
          const isApi = apiRequestRegex.test(config.url);
          if (isGet && !isInline && !isApi) {
            const isHtml = /\.html$/.test(config.url);
            const separator = (config.url.indexOf('?') >= 0) ? '&' : '?';
            config.url = config.url + separator + BuildId;
            if (L10n.language && isHtml) {
              // Only prefix the request with the language if:
              // - We have a valid language.
              // - The request is a GET for an html file.
              // - It's not a request for an inlined template.
              config.url = L10n.language + '/' + config.url;
            }
            config.url = StaticAssetsUrlPrefix + config.url;
          }
          return config;
        },
        responseError: (rejection: any) => {
          Tableau.Logger().error('http error ' + rejection.status + ' for request ' + rejection.config.url);
          if (rejection.status === 404) {
            if (rejection.config.url.indexOf('/error.html') >= 0) {
              // if we can't fetch the error page it's probably something pretty fundamental
              if (L10n.language && L10n.language !== 'en' && rejection.config.url.indexOf(L10n.language) === 0){
                Tableau.Logger().error("Your language setting '" + L10n.language + "' may be invalid.");
                // potential improvement - create a language service and just change the language to 'en' for a better experience
              }
              goToFatalErrorState('Failed to load error handling page.');
            }
            else if (rejection.config.url.indexOf('messages.') >= 0) {
              // failed to get strings for this language - it will fall back to English in AuthenticationService but if this is english...
              if (L10n.language === 'en') {
                goToFatalErrorState('Failed to load strings for UI.');
              }
            }
          }
          return $q.reject(rejection);
        }
      };
    }]);

    // Angular does not support SCE on IE7-.
    // This browser detection matches the check that Angular performs internally.
    if (navigator.userAgent.match(/msie/i) && (<any>document).documentMode > 0 && (<any>document).documentMode < 8) {
      $sceProvider.enabled(false);
    }
  }
]);
